import '../css/app.css'

import $ from 'jquery'
window.$ = window.jQuery = $

import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()


import LazyLoad from 'vanilla-lazyload'

import Headroom from 'headroom.js'

import Splide from '@splidejs/splide'
import { Video } from '@splidejs/splide-extension-video';

if ($('#similar').length > 0) {
  new Splide('#similar', {
    type: 'loop',
    focus: 'center',
    waitForTransition: false,
    pagination: false,
    arrows: true,
    perPage: 5,
    perMove: 1,
        breakpoints : {
          '1024': {
            perPage : 2,
          }
        },
      } ).mount();
    }



new Splide('#announcement', {
  type: 'loop',
  perPage: 1,
  autoplay: true,
  pagination: false,
  arrows: false,
}).mount()





if ($('#homeBanner').length > 0) {
  new Splide('#homeBanner', {
    type: 'loop',
    focus: 'center',
    video: {
      autoplay: true,
      mute: true,
      loop: false,
      disableOverlayUI: true,
      hideControls: true,
    },
    autoplay: true,
    pauseOnHover: true,
    perPage: 1,
    perMove: 1,
    pagination: false,
    arrows: false,
  }).mount({ Video })
}
import Player from '@vimeo/player'
var players = []
$('.inner').each(function () {
  players.push({
    player: new Player($(this).find('iframe').get(0)),
    top: $(this).position().top,
    status: 'paused',
  })
})
var viewportHeight = $(window).height()

$(window).on('scroll', function () {
  var scrollPos = $(window).scrollTop()
  for (var i = 0; i < players.length; i++) {
    var elementFromTop = players[i].top - scrollPos
    var status =
      elementFromTop > 0 && elementFromTop < players[i].top + viewportHeight ? 'play' : 'pause'
    if (players[i].status != status) {
      players[i].status = status
      players[i].player[status]()
      console.log(i, status)
    }
  }
})





// select your header or whatever element you wish
const header = document.querySelector('#main-nav')

// construct an instance of Headroom, passing the header element.
const headroom = new Headroom(header, {
  offset: 0,
  tolerance: {
    up: 0,
    down: 0,
  },
  classes: {
    initial: 'header--fixed',
    pinned: 'slideDown',
    unpinned: 'slideUp',
    top: 'top',
    notTop: 'not-top',
  },
})

// initialise
headroom.init()

// When the page is at the top, remove the slideDown class.
window.addEventListener('scroll', () => {
  if (window.pageYOffset === 0) {
    header.classList.remove('slideDown')
  }
})

import ScrollReveal from 'scrollreveal';

// Basic fade-up animation
ScrollReveal().reveal('.sr-fade-up', {
  distance: '40px',
  origin: 'bottom',
  duration: 800,
  easing: 'ease-out',
  reset: false,           // true = animate every time it enters
  viewFactor: 0.3,        // only start when 30% is visible
  viewOffset: { top: 50 } // wait until the element is well in view
});

// Basic fade-up animation
ScrollReveal().reveal('.sr-fade-lg', {
  distance: '80px',
  origin: 'bottom',
  duration: 600,
  easing: 'ease-out',
  reset: false,           // true = animate every time it enters
  viewFactor: 0.3,        // only start when 30% is visible
  viewOffset: { top: 50 } // wait until the element is well in view
});
ScrollReveal().reveal('.sr-fade-zoom-in', {
  scale: 0.85,           // start zoomed out
  opacity: 0,            // start fully transparent
  duration: 800,         // animation duration (ms)
  easing: 'ease-out',    // easing function
  delay: 100,            // optional delay
  reset: false,          // true = re-animate every scroll into view
  viewFactor: 0.3,       // % of element that must be visible
});
ScrollReveal().reveal('.sr-fade', {
  opacity: 0,
  duration: 600,
  easing: 'ease-out',
  reset: false,           // true = animate every time it enters
});
// Optional: slide from left
ScrollReveal().reveal('.sr-left', {
  distance: '60px',
  origin: 'left',
  duration: 1000,
  easing: 'ease-in-out',
  reset: false,
  viewFactor: 0.2,
});

// Optional: slide from right
ScrollReveal().reveal('.sr-right', {
  distance: '60px',
  origin: 'right',
  duration: 1000,
  easing: 'ease-in-out',
  reset: false,
  viewFactor: 0.2,
});



// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR')
  })
}
